import { ReactNode } from 'react';

export enum TOOLTIP_POSITION {
  TOP = 'top',
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
}

type StyleObject = {
  element?: React.CSSProperties;
  popup?: React.CSSProperties;
};

export type TooltipProps = {
  children: ReactNode;
  popup: ReactNode;
  position?: TOOLTIP_POSITION;
  hoverable?: boolean;
  extendStyles?: StyleObject;
};

export type HoverElementProps = {
  hoverable: boolean;
};

export type HoverPopupProps = {
  width: string;
  position: string;
};
